/**
 * Vue directives setup
 */
import Vue from 'vue';

Vue.directive('datepicker', {
    bind: function (el, binding, vnode) {

        var dateFormat  = 'dd/mm/yy';
        var minDate     = '';

        if ($(el).attr('format') == 'mdy') {
            dateFormat = 'mm/dd/yy';
        }

        if ($(el).attr('minDate') > 0) {
            var minDate = '-'+$(el).attr('minDate');
        }

        $(el).datepicker({
            dateFormat: dateFormat,
            showOtherMonths: true,
            selectOtherMonths: true,
            minDate: minDate,
            onSelect: function (date) {
                Vue.set(vnode.context, binding.expression, date);
            }
        });
    },
    update: function (el, binding) {
        $(el).datepicker('setDate', binding.value);
    }
});

import Sortable from 'sortablejs';

Vue.directive('sortable', {
    bind: function (el, binding, vnode) {

        var self = this;

        var params = {
            onUpdate: function () {
                vnode.context.$emit('sort', this.toArray());
            },
            handle: '.handle',
            dataIdAttr: 'colname',

        }

        el.sortable = Sortable.create(el, params);
    },

    update: function (el, binding) {
        return false;
        console.log('update');
    }
});

Vue.directive('sync', {
    update: function (el, binding, vnode) {
        Vue.set(vnode.context, binding.expression, vnode.componentInstance.$data);
    }
});

Vue.directive('click-outside', {
    bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }

            console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
                binding.value(e)
            }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
    },

    unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

    }
});

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        // here I check that click was outside the el and his childrens
        if (!(el == event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

/**
 * Directive to execute a function when hovering over a dom element
 * ex: <span v-hover="{over: onHoverFn, leave: onLeaveFn}"></span>
 * 
 * Example of use CursorTooltip.vue
 */
Vue.directive('hover', {
    bind: function (el, binding, vNode) {

        const compName = vNode.context.name

        // Provided expression must evaluate to an object.
        if (typeof binding.value !== 'object') {
            let warn = `[v-hover]: provided expression '${binding.expression}' is not an object, but it needs to be.`
            if (compName) { warn += `\nFound in component '${compName}'` }
            console.log(warn)
        }

        // Provided expression must have at least one "over" or "leave" properties
        if (!binding.value || (!binding.value?.over && !binding.value?.leave)) {
            let warn = `[v-hover]: object provided does not have 'over' or 'leave' properties. Needs at least one to be of use`
            if (compName) { warn += `\nFound in component '${compName}'` }
            console.log(warn)
        }

        el.__vHoverOver__  = binding.value?.over || (() => {})
        el.__vHoverLeave__ = binding.value?.leave || (() => {})

        // Add Event Listeners
        el.addEventListener('mouseover', el.__vHoverOver__)
        el.addEventListener('mouseleave', el.__vHoverLeave__)
    },
    unbind: function (el, binding) {
        // Remove Event Listeners
        el.removeEventListener('mouseover', el.__vHoverOver__)
        el.removeEventListener('mouseleave', el.__vHoverLeave__)
        delete el.__vHoverOver__
        delete el.__vHoverLeave__
    }
});